export default __webpack_public_path__ + "static/media/default.e49cc67f.svg";